import React, {FC} from "react";
import {translateKey} from "../language/translate";

type Props = {
  id: string
  message?: string
  textCenter?: boolean
  widthRule?: string
};

export const ValidationError: FC<Props> = ({
                                             id,
                                             message,
                                             textCenter = false,
                                             widthRule= ""}) => {
  let className = "";
  let translatedMessage = "";
  if (message) {
    className = `p-2 break-words text-red-600 text-sm ${textCenter && "text-center"} ${widthRule}`;
    translatedMessage = translateKey(message);
  }
  return <div id={id} className={className}>
    {translatedMessage}&nbsp;
  </div>
};

type FieldGroupProps = {
  children: React.ReactNode
  className?: string
  dataTestId?: string
}

export const FieldGroup: FC<FieldGroupProps> = ({children, className = "", dataTestId = ""}) => {
  return <div className={className} data-testid={dataTestId}>{children}</div>
}
